export const SpinnerProperty = {
  Size: 'size',
  ColorScheme: 'colorScheme',
};

export default SpinnerProperty;
